"use client";

import MainContactUs from '@/components/layout/MainContactUs';

export default function ContactUs() {
  return (
    <main className="relative overflow-hidden mb-16 lg:mb-32 2xl:mb-64 px-4 sm:px-6 lg:px-12 xl:px-24 2xl:px-48 py-12 sm:py-16 lg:py-24">
      <MainContactUs />
    </main>
  );
}
